<template>
  <div
    ref="bannerRef"
    class="listing-banner-universal-sketch-tags"
  >
    <div class="info">
      <div
        class="info__title"
        v-html="props.banner.title"
      />
      <banner-tags
        :tags="tags"
        @on-click="emit('onClick')"
      />
    </div>
    <div class="image">
      <ui-image
        :src="props.banner.image"
        :alt="t('bannerInjection.bannerImage')"
        loading="lazy"
        decoding="async"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import BannerTags from './BannerTags.vue';
  import type { GetListingBannersItemBannerParamsResponse, ListingBannersButton } from '@/shared/api/experience';
  import { useI18n } from '@experience/i18n';
  import { UiImage } from '@experience/core-image-ui';
  import ru from '../i18n/ru.json';

  interface Props {
    banner: GetListingBannersItemBannerParamsResponse;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<{ onClick: [] }>();

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const tags = computed(() => (props.banner?.tags || []) as ListingBannersButton[]);
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as typography;

  .listing-banner-universal-sketch-tags {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0;
  }

  .info {
    margin-bottom: 24px;
  }

  .info__title {
    margin-bottom: 24px;

    @include typography.base-700-500-extra;
  }

  .info__description {
    margin-bottom: 16px;

    @include typography.base-400-400-regular;
  }

  .image {
    display: flex;
    flex-grow: 1;
    justify-content: center;

    img {
      max-width: 100%;
    }
  }
</style>
